<div id="cont" class="box" (keydown.arrowleft)="previousMonthButtonClick()"
  (keydown.arrowright)="nextMonthButtonClick()" (swipeleft)="nextMonthButtonClick()"
  (swiperight)="previousMonthButtonClick()" style="height: 100%; ">
  <div class="header-date" style="min-height: 60px;">

    <button mat-icon-button class="buttons" (click)="previousMonthButtonClick()">
      <mat-icon>
        arrow_back_ios
      </mat-icon>
    </button>

    <div style="display: flex; flex-direction: row; justify-content: center center;">
      <!--  <button mat-icon-button (click)="addEventClicked()">
      <mat-icon>add</mat-icon>
    </button>-->
    <span>
      {{ actDate }}
    </span>
    <button mat-icon-button (click)="showChangeDate = !showChangeDate">
      @if (!showChangeDate) {
        <mat-icon>keyboard_arrow_down</mat-icon>
      }
      @if (showChangeDate) {
        <mat-icon>keyboard_arrow_up</mat-icon>
      }

    </button>
  </div>
  <button mat-icon-button class="buttons" (click)="nextMonthButtonClick()">
    <mat-icon>
      arrow_forward_ios
    </mat-icon>
  </button>


</div>

@if (showChangeDate) {
  <div class="header-select-date" style="min-height: 30px;">
    <select name="year" class="selects" (change)="onYearChange($event)">
      @for (y of years; track y) {
        <option [value]="y" [selected]="y === currentYear">{{ y }}
        </option>
      }
    </select>
    <select name="month" class="selects" (change)="onMonthChange($event)">
      @for (m of months; track m) {
        <option [value]="m.id" [selected]="m.id === currentMonth">{{ m.name }}
        </option>
      }
    </select>
  </div>
}



<div class="calendar-container">
  <div class="calendar-div">
    <div class="weekdays-container" style="min-height: 30px;">
      @for (day of weekdays; track day) {
        <div class="weekdays">
          @if (!isSmall) {
            <span>
              {{day.name}}
            </span>
          }
          @if (isSmall) {
            <span>
              {{day.shortName}}
            </span>
          }
        </div>
      }
    </div>

    @for (item of arrCalendar; track item) {
      <div class="cell-container" style="height: 100%;">
        @for (test of item; track test) {
<div class="cell-item"  [ngStyle]="{
                        backgroundColor:
                          test.day == actDay &&
                          test.month == actMonth - 1 &&
                          test.year == actYear
                            ? 'lightblue'
                            : 'white'
                      }" style="height: 100%;">
            <div style="height: 100%; flex-direction: column; display: flex;">
              <div>
              <b class="calendar-days" [ngStyle]="{
                  color: test.month == currentMonth ? 'black' : 'lightgray'
                }">{{ test.day }}
                </b>
                <!--      <span *ngIf="test.events && test.events.length > 0 && isSmall" class="dot"></span>-->
              </div>
              <!--         <div *ngIf="!isSmall" style="height: 100%; overflow-x: hidden; overflow-y: scroll;"> -->
              <div  style="height: 80px; overflow-x: hidden; overflow-y: scroll;">
                @for (event of test.events; track event) {
                  <div class="row-items" [ngStyle]="{ backgroundColor: event.color }">
                    <!--
                    {{event.id}}-
                    {{event.title}}-
                    {{event.desc}}-->
                    @if (event.color=='green') {
                      <span (click)="openDialog(event)">{{ event.startTime }} : {{event.title}}</span>
                    } @else {
                      <span>{{ event.startTime }} : {{event.title}}</span>
                    }
                    @if (event.link && event.color=='blue') {
                      <span><br><a href="{{event.link}}" target="_blank" style="color:white">LINK</a></span>
                    } </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }



    </div>
  </div>
</div>